import { getFormValue } from '../utils'

export const prepareValuesForPreview = (eventType, formValues) => ({
  name: getFormValue(eventType.name, formValues.name)
})
